module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_ZoomOut_16"],"path":[{"$":{"d":"M10,8H4V6h6Zm4.42,8-3.32-3.32a7,7,0,1,1,1.56-1.56L16,14.42ZM12.5,7A5.5,5.5,0,1,0,7,12.5,5.51,5.51,0,0,0,12.5,7Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_ZoomOut_16.svg
// module id = pCX+
// module chunks = 1